import { isSSR } from 'js/isSSR'

export default (test, methods) => {
  const adapter = {}

  // Create noop tracking functions when server rendering (prerendering)
  if (
    (typeof navigator !== 'undefined' &&
      navigator.userAgent.match('DisableForTesting')) ||
    isSSR
  ) {
    Object.keys(methods).map(key => {
      adapter[key] = () => {}
    })
  } else {
    const init = new Promise(resolve => {
      const interval = setInterval(() => {
        if (test()) {
          resolve()
          clearInterval(interval)
        }
      }, 50)
    })

    Object.keys(methods).map(key => {
      adapter[key] = (...params) => init.then(() => methods[key](...params))
    })
  }
  return adapter
}
